export default __webpack_public_path__ + "static/media/Rubik-Light.44b62d60.ttf";